import { sitesPipelineStore } from "../store";
import { useSnapshot } from "valtio";
import { SitesByStage } from "react-migration/domains/sites";

export const useVueSitesByStage: () => SitesByStage = () => {
  const { vueSitesByStage } = useSnapshot(sitesPipelineStore);

  return vueSitesByStage as SitesByStage;
};
